module.exports = __webpack_public_path__ + "static/media/bg_8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_8.png
// module id = 53
// module chunks = 0